import { render, staticRenderFns } from "./GroupMealsDaysMealsChart.vue?vue&type=template&id=0995ba1e"
import script from "./GroupMealsDaysMealsChart.vue?vue&type=script&lang=js"
export * from "./GroupMealsDaysMealsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports